import { render, staticRenderFns } from "./Tokenize.vue?vue&type=template&id=298db93e&scoped=true&"
import script from "./Tokenize.vue?vue&type=script&lang=js&"
export * from "./Tokenize.vue?vue&type=script&lang=js&"
import style0 from "./Tokenize.vue?vue&type=style&index=0&id=298db93e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298db93e",
  null
  
)

export default component.exports